import React from 'react';
import { Nav } from 'react-bootstrap';
import { House, Gear, Table } from 'react-bootstrap-icons';

const AdminSidebar = ({ collapsed, toggleSidebar }) => {
  return (
    <div
      style={{
        width: collapsed ? '60px' : '200px',
        background: '#343a40',
        height: '100vh',
        color: 'white',
        position: 'fixed',
        transition: 'width 0.3s ease-in-out',
        zIndex: 1000,
      }}
    >
      <div className="d-flex align-items-center justify-content-between p-2">
        {!collapsed && <h5 className="text-white m-0">Admin</h5>}
        <button
          className="btn btn-sm btn-light"
          onClick={toggleSidebar}
        >
          {collapsed ? '›' : '‹'}
        </button>
      </div>
      <Nav className="flex-column px-2">
        <Nav.Link href="/dashboard" className="text-white">
          <House /> {!collapsed && 'Dashboard'}
        </Nav.Link>
        <Nav.Link href="/updateoximo" className="text-white">
          <Gear /> {!collapsed && 'Oximo Price'}
        </Nav.Link>
        <Nav.Link href="/dashboard/aspl-prices" className="text-white">
          <Gear /> {!collapsed && 'ASPL Prices'}
        </Nav.Link>
        <Nav.Link href="/dashboard/manual-payment-orders" className="text-white">
          <Table /> {!collapsed && 'Manual Payments'}
        </Nav.Link>
        <Nav.Link href="/tables" className="text-white">
          <Table /> {!collapsed && 'Tables'}
        </Nav.Link>
      </Nav>
    </div>
  );
};

export default AdminSidebar;
